<template>
  <div class="p-3">
    <b-card>
      <b-progress class="mt-3 mb-3" :value="progress" variant="primary"></b-progress>
      <stripe-checkout
        ref="checkoutRef"
        :pk="publishableKey"
        :session-id="sessionId"
      />
      <step
        v-if="step === 1"
        position="1"
        :title="msgtitle || 'Select or upgrade your plan'"
        :description="msgdescription || 'Select or upgrade your plan. Click NEXT to continue with your current plan'"
        >
        <b-row>
          <div id="pricing-tabs" style="width: 100%">

               <div id="togglePlanDivDesktop" class="togglePlanDiv" style="margin-top:0">
                <!-- <p class="chooseBilling">Choose your billing:</p> -->
                <p style="color:white; margin:0">Choose your billing:</p>
                <div class="row togglePlan">
                    <div class="col-6">
                        <p @click="TogglePlan('annual')" id="annual" :class="{active: period == 'annual'}">Annual</p>
                    </div>
                    <div class="col-6">
                        <p @click="TogglePlan('monthly')" id="monthly" :class="{active: period == 'monthly'}">Monthly</p>
                    </div>
                </div>
          
                <div style="margin-top: 13px; margin-bottom:5px">
                  <p v-if="period==='monthly'">Switch to annual plan to save <strong>20% off</strong></p>
                  <p v-else>You are saving <strong>$240</strong> by choosing to pay annually</p>
                </div>
                <div>
                  <div>
                    <b-button
                    v-if="plan_id !=100"
                    size="md"
                    squared
                    variant="info"
                    @click="selectPlan(plan_id)"
                    style="float: right; margin-bottom: 2px;">
                    <span>Next</span>
                  </b-button>
                  </div>
                </div>
                <!-- <div class="saveOnAnnual">
                    <div class="box ">
                        <p id="savePromptDesktop">Switch to annual plan to save <strong>20% off</strong></p>
                    </div>
                </div> -->
            </div>

            <div id="fdw-pricing-table" v-if="plans">
              <div v-for="plan in plans" :key="plan.plan_id" :class="`plan plan` + handleStyle(plan.plan_id)">
                <div v-if="plan.plan_id ===2" class="most-popular">Our Most Popular Plan</div>
                <div class="header">{{ plan.name }}
                  <h6 v-if="plan_id === plan.plan_id" style="color: green;">(Current plan)</h6>
                  <h6 v-else-if="plan_id ===100 && plan.plan_id==2" style="color: green;">(Current free plan)</h6>

                </div>
                <!-- <div class="price" v-if="plan.plan_type !== 'enterprise'"><sup>$</sup>{{ plan.amount }}<span v-if="plan.plan_id===2" class="monthly">/mo</span></div> -->
               
                  <div class="price" v-if="plan.plan_id ===1" ><sup>$</sup>{{ plan.amount }}<span class="monthly"></span></div>
                
                  <div class="price" v-else-if="plan.plan_id ===2 && period=='monthly'"><sup>$</sup>119<span v-if="plan.plan_id===2" class="monthly"></span></div>
               
                  <div class="price" v-else-if="plan.plan_id === 2 && period=='annual'" ><sup>$</sup>99<span v-if="plan.plan_id===2" class="monthly"></span></div>
                
                  <div class="price contact-sales" v-else>Contact Sales</div>
                 <div>
                   <p v-if="plan.plan_id ===1">1 user for 30 days</p>
                   <p v-else-if="plan.plan_id ===2 && period=='monthly'">per user per month</p>
                   <p v-else-if="plan.plan_id ===2 && period=='annual'">per user per month (Billed annually)</p>
                   
                   <p v-else>custom pricing</p>
                 </div>
                 <!-- new -->
                 <div class="planTop" v-if="(plan.plan_type !== 'enterprise') &&(plan_id === 100 || plan_id === 99)" >
                
                  

                    <a style="cursor:pointer;" class="signup" @click="selectPlan(plan.plan_id)" >Select Plan</a>
                 </div>
                 <div class="planTop" v-else-if="plan.plan_type !== 'enterprise' && plan_id === plan.plan_id" :disabled=true>
                    <a style="pointer-events: none;cursor: default;" class="signup" @click="selectPlan(plan.plan_id)" >Selected</a>

                 </div>
                 <div class="planTop" v-else-if="plan.plan_type !== 'enterprise' && plan_id !== plan.plan_id && (plan_id !== 100 || plan_id !== 99)">
                    <a style="cursor:pointer;" class="signup" @click="selectPlan(plan.plan_id)"  >{{plan.plan_type!=='on_demand' ?'Upgrade':'Downgrade'}}</a>

                 </div>
                  <div class="planTopEnterprise" v-else>
                    <a style="cursor:pointer;" class="signup" @click="show_calendly()" >Contact Sales</a>
                  </div> 
               
                <ul v-if="plan.features">
                  <!-- <li><p><b-icon icon="check-circle-fill" scale="1" variant="success"></b-icon>
                    360 Customer Views</p></li> -->
                  <li v-if="plan.plan_type === 'enterprise'"><p><img :src="assetPath('img/icon/check.png')" />
                    <strong><em> All Standard Features Plus</em></strong></p></li>
                  <li v-if="!!plan.features.general_data_insights"><p><img :src="assetPath('img/icon/check.png')" />
                    General Data Insights</p></li>
                  <li v-if="!!plan.features.customer_360_view"><p><img :src="assetPath('img/icon/check.png')" />
                    360 Customer Views</p></li>
                  <li v-if="!!plan.features.segmentation"><p><img :src="assetPath('img/icon/check.png')" />
                    Segmentation</p></li>
                  <li v-if="!!plan.features.user_support"><p><img :src="assetPath('img/icon/check.png')" />
                    User Support</p></li>
                  <li v-if="!!plan.features.file_upload"><p><img :src="assetPath('img/icon/check.png')" />
                    CSV/Excel file uploads</p></li>
                  <li v-if="!!plan.features.number_data_sources"><p><img :src="assetPath('img/icon/check.png')" />
                    <strong> {{plan.features.number_data_sources}}</strong> Data Sources</p></li>
                  <li v-if="!!plan.features.number_of_records"><p><img :src="assetPath('img/icon/check.png')" />
                    <strong> {{plan.features.number_of_records}}</strong> Rows of Data</p></li>
                  <li v-if="!!plan.features.data_retention_days"><p><img :src="assetPath('img/icon/check.png')" />
                    <strong> {{plan.features.data_retention_days}} days</strong> Data Retention</p></li>
                  <li v-if="!!plan.features.data_export_support"><p><img :src="assetPath('img/icon/check.png')" />
                    Data Export Support</p></li>

                  <li v-if="!!plan.features.unlimited_users"><p><img :src="assetPath('img/icon/check.png')" />
                    Unlimited Users</p></li>
                  <li v-if="!!plan.features.custom_business_insights"><p><img :src="assetPath('img/icon/check.png')" />
                    Custom Business Insights</p></li>
                  <li v-if="!!plan.features.integrations"><p><img :src="assetPath('img/icon/check.png')" />
                    Integrations</p></li>
                  <li v-if="!!plan.features.customizable_ui"><p><img :src="assetPath('img/icon/check.png')" />
                    Customizable UI</p></li>
                  <li v-if="!!plan.features.customer_engagements"><p><img :src="assetPath('img/icon/check.png')" />
                    Customer Engagement<br/><em>(Email, SMS and Voice Call)</em></p></li>
                  <li v-if="!!plan.features.unlimited_records"><p><img :src="assetPath('img/icon/check.png')" />
                    Unlimited Records</p></li>
                  <li v-if="!!plan.features.multiple_data_sources"><p><img :src="assetPath('img/icon/check.png')" />
                    Multiple Data Sources</p></li>
                  <li v-if="!!plan.features.account_manager_support"><p><img :src="assetPath('img/icon/check.png')" />
                    Account Manager Support</p></li>
                </ul>
                
                    <!-- <a style="cursor:pointer;" class="signup" @click="selectPlan(plan.plan_id)" v-if="(plan.plan_type !== 'enterprise') &&(plan_id === 100 || plan_id === 99)" >Select Plan</a>

                    <a class="signup" @click="selectPlan(plan.plan_id)" v-else-if="plan.plan_type !== 'enterprise' && plan_id === plan.plan_id">Select Plan</a>
                    <a style="cursor:pointer;" class="signup" @click="selectPlan(plan.plan_id)" v-else-if="plan.plan_type !== 'enterprise' && plan_id !== plan.plan_id && (plan_id !== 100 || plan_id !== 99)" >{{plan.plan_type!=='on_demand' ?'Upgrade':'Downgrade'}}</a>

                    <a style="cursor:pointer;" class="signup" @click="show_calendly()" v-else>Contact Sales</a> -->
                
              </div>
            </div>
            

             <div id="pricing-table-mobile" v-if="plans">
              <div v-for="plan in plans" :key="plan.plan_id" :class="`plan plan` + handleStyle(plan.plan_id)">
                <div class="header">{{ plan.name }}</div>
                <div class="price" v-if="plan.plan_type !== 'enterprise'"><sup>$</sup>{{ plan.amount }}</div>
                <div class="price contact-sales" v-else>Contact Sales</div>
                <ul v-if="plan.features">
                  <!-- <li><p><b-icon icon="check-circle-fill" scale="1" variant="success"></b-icon>
                    360 Customer Views</p></li> -->
                  <li v-if="plan.plan_type === 'enterprise'"><p><img :src="assetPath('img/icon/check.png')" />
                    <strong><em> All Standard Features Plus</em></strong></p></li>
                  <li v-if="!!plan.features.general_data_insights"><p><img :src="assetPath('img/icon/check.png')" />
                    General Data Insights</p></li>
                  <li v-if="!!plan.features.customer_360_view"><p><img :src="assetPath('img/icon/check.png')" />
                    360 Customer Views</p></li>
                  <li v-if="!!plan.features.segmentation"><p><img :src="assetPath('img/icon/check.png')" />
                    Segmentation</p></li>
                  <li v-if="!!plan.features.user_support"><p><img :src="assetPath('img/icon/check.png')" />
                    User Support</p></li>
                  <li v-if="!!plan.features.file_upload"><p><img :src="assetPath('img/icon/check.png')" />
                    CSV/Excel file uploads</p></li>
                  <li v-if="!!plan.features.number_data_sources"><p><img :src="assetPath('img/icon/check.png')" />
                    <strong> {{plan.features.number_data_sources}}</strong> Data Sources</p></li>
                  <li v-if="!!plan.features.number_of_records"><p><img :src="assetPath('img/icon/check.png')" />
                    <strong> {{plan.features.number_of_records}}</strong> rows of data</p></li>
                  <li v-if="!!plan.features.data_retention_days"><p><img :src="assetPath('img/icon/check.png')" />
                    <strong> {{plan.features.data_retention_days}} days</strong> Data Retention</p></li>
                  <li v-if="!!plan.features.data_export_support"><p><img :src="assetPath('img/icon/check.png')" />
                    Data Export Support</p></li>

                  <li v-if="!!plan.features.unlimited_users"><p><img :src="assetPath('img/icon/check.png')" />
                    Unlimited Users</p></li>
                  <li v-if="!!plan.features.custom_business_insights"><p><img :src="assetPath('img/icon/check.png')" />
                    Custom Business Insights</p></li>
                  <li v-if="!!plan.features.integrations"><p><img :src="assetPath('img/icon/check.png')" />
                    Integrations</p></li>
                  <li v-if="!!plan.features.customizable_ui"><p><img :src="assetPath('img/icon/check.png')" />
                    Customizable UI</p></li>
                  <li v-if="!!plan.features.customer_engagements"><p><img :src="assetPath('img/icon/check.png')" />
                    Customer Engagement<br/><em>(Email, SMS and Voice Call)</em></p></li>
                  <li v-if="!!plan.features.unlimited_records"><p><img :src="assetPath('img/icon/check.png')" />
                    Unlimited Records</p></li>
                  <li v-if="!!plan.features.multiple_data_sources"><p><img :src="assetPath('img/icon/check.png')" />
                    Multiple Data Sources</p></li>
                  <li v-if="!!plan.features.account_manager_support"><p><img :src="assetPath('img/icon/check.png')" />
                    Account Manager Support</p></li>
                </ul>
                <!-- <a class="signup" ></a> -->
                  <a style="cursor:pointer;" class="signup" @click="selectPlan(plan.plan_id)" v-if="(plan.plan_type !== 'enterprise') &&(plan_id === 100 || plan_id === 99)" >Select Plan</a>

                    <a class="signup" @click="selectPlan(plan.plan_id)" v-else-if="plan.plan_type !== 'enterprise' && plan_id === plan.plan_id">Select Plan</a>
                    <a style="cursor:pointer;" class="signup" @click="selectPlan(plan.plan_id)" v-else-if="plan.plan_type !== 'enterprise' && plan_id !== plan.plan_id && (plan_id !== 100 || plan_id !== 99)" >{{plan.plan_type!=='on_demand' ?'Upgrade':'Downgrade'}}</a>

                    <a style="cursor:pointer;" class="signup" @click="show_calendly()" v-else>Contact Sales</a>
                
              </div>
            </div>
            <!--  </div>-->
          </div>
          <!-- <b-col cols :md=9></b-col>
          <b-col cols :md=3 class="mt-2">
            <b-button v-if="step !== 1" size="md" squared variant="default" @click="previousStep" 
            style="float: right">
              <span>Previous</span>
            </b-button>
            <b-button v-if="step !== totalSteps && !createProject" size="md" squared variant="info" :disabled="plan_id == null" 
              @click="nextStep" style="float: right">
              <span>Next</span>
            </b-button>
          </b-col> -->
          <!-- <div>
                    <b-button
                    v-if="plan_id !=100"
                    size="md"
                    squared
                    variant="info"
                    @click="selectPlan(plan_id)"
                    style="float: right; margin-bottom: 2px;">
                    <span>Next</span>
                  </b-button>
            </div> -->
          <b-col cols :md=6>
                
                
              </b-col> 
               <b-col cols :md=6>
                
                 <b-button
                  v-if="plan_id !=100"
                  size="md"
                  squared
                  variant="info"
                  @click="selectPlan(plan_id)"
                  style="float: right; margin-bottom: 2px">
                  <span>Next</span>
                </b-button>
              </b-col>
        </b-row>
            <!-- <b-row>
              
            </b-row> -->
      </step>
      <step
        v-if="step===2"
        position="2"
        title="Pay for your Plan"
        description="">
        <b-row>
          <!-- <b-col cols :md=6>
            
            
          
            <a class="signup" @click="payForPlan()">Pay for Plan</a>
          </b-col> -->

          <b-col cols :md=11>
           <!-- <b-card-group deck>         
                <b-card>
                    <div>
                    <p>To complete payment, You will be redirected to a secure website on {{payment_option}}</p>
                  </div>
                    <div>
                        <b-row class="text-center">
                              <b-col>Checkout</b-col>
                        </b-row>

                      <div style="overflow-x: auto;">
                          <b-table 
                          show-empty
                            hover
                            small
                            head-variant="dark" 
                          :items="plan_summary">
                
                          </b-table>
                        </div>
                    </div>

                  </b-card>
             
                  <b-card>                             
                      <b style="text-align:center;">Payment Methods</b>
                        <div>
                          <p>We accept payment from VISA, MasterCard, Mobilemoney etc</p>
                      </div>
                      <div>
                        <p></p>
                      </div>
                      <div>
                        <img :src="assetPath('localpayment2.png')" style="max-height:55px;"/>

                        <img :src="assetPath('visa_master_card1.png')" style="max-height:55px;"/>
                      </div>          
                </b-card>
           
           </b-card-group> -->
          <div id="pricing-tabs2" style="width: 100%">
            <div id="fdw-pricing-table2">
              <div class="pay plan2">
                    <div>
                    <p>To complete payment, You will be redirected to a secure website on {{payment_option}}</p>
                  </div>
                    <div>
                        <!-- <b-row class="text-center">
                              <b-col>Checkout</b-col>
                        </b-row> -->

                      <div style="overflow-x: auto;">
                          <b-table 
                       
                            hover
                            small
                            striped
                            table-variant="dark"
                          :items="plan_summary">
                
                          </b-table>
                        </div>
                    </div>

              </div>
             
                <div class="pay plan1">
                                               
                      <b style="text-align:center;">Payment Methods</b>
                        <div>
                          <p>We accept payment from VISA, MasterCard, Mobilemoney etc</p>
                      </div>
                      <div>
                        <p></p>
                      </div>
                      <div>
                        <img :src="assetPath('localpayment2.png')" style="max-height:55px;"/>

                        <img :src="assetPath('visa_master_card1.png')" style="max-height:55px;"/>
                      </div>          
               </div>
            </div>
          </div>
          </b-col>

          
        </b-row>

        <b-row>
          <b-col cols :md=6 style="margin-top:5px;">
               <b-button
              v-if="step !== 1"
              size="md"
              squared
              variant="outline-primary"
              @click="previousStep"
              
              style="float: left">
              <span>Change plan</span>
            </b-button>
          </b-col>
          <b-col cols :md=6 style="margin-top:5px;">
            <b-button
              v-if="step !== totalSteps"
              size="md"
              squared
              variant="info"
              @click="payForPlan"
              style="float: right">
              <span>Pay for plan</span>
            </b-button>
         
          </b-col>
        </b-row>
      </step>
      <step
        v-if="step===3"
        position="3"
        title="Payment Completed Successfully"
        description="">
        <!-- <h5>Step 1: Create a Project</h5> -->
        <b-row>
          <b-col :md=4>
            <b-card no-body 
              :title="project.name" 
              bg-variant="primary"
              @click="viewInsights()" style="cursor: point">
              <div class="px-3 py-2">
                <h5>View General Data Insights</h5>
                <h6>{{ project.name || 'Untitled project' }}</h6>
                <b-row align-v="start" class="mt-2">
                  <card-detail name="File(s)" :span="6">
                    <span v-if="true">{{ Object.keys(project.files).length | formatInt }}</span>
                    <i v-else class="fa fa-spin fa-spinner"/>
                  </card-detail>
                </b-row>
                <h6 v-if="project.createdAt"> Created {{ project.createdAt |  humanize }} </h6>
              </div>

              <b-card-footer class="px-2 py-1 bg-white" style="border: none;">
                <b-button
                  v-if="step === totalSteps"
                  size="md"
                  squared
                  variant="outline-info"
                  @click="viewInsights()"
                  style="float: right">
                  <span>General Data Insights</span>
                </b-button>
              </b-card-footer>
            </b-card>
          </b-col>
          <b-col :md=4>
            <b-card no-body 
              :title="project.name" 
              bg-variant="primary"
              @click="viewStandardInsights()" style="cursor: point">
              <div class="px-3 py-2">
                <h5>View Business Headlines</h5>
                <h6>{{ project.name || 'Untitled project' }}</h6>
                <b-row align-v="start" class="mt-2">
                  <card-detail name="File(s)" :span="6">
                    <span v-if="true">{{ Object.keys(project.files).length | formatInt }}</span>
                    <i v-else class="fa fa-spin fa-spinner"/>
                  </card-detail>
                </b-row>
                <h6 v-if="project.createdAt"> Created {{ project.createdAt |  humanize }} </h6>
              </div>

              <b-card-footer class="px-2 py-1 bg-white" style="border: none;">
                <b-button
                  v-if="step === totalSteps"
                  size="md"
                  squared
                  variant="outline-info"
                  @click="viewStandardInsights()"
                  style="float: right">
                  <span>Business Headlines</span>
                </b-button>
              </b-card-footer>
            </b-card>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col cols :md=6></b-col>
          <b-col cols :md=6>
            <b-button
              v-if="step === totalSteps"
              size="md"
              squared
              variant="info"
              @click="viewInsights()"
              style="float: right">
              <span>View insights</span>
            </b-button>
            <b-button
              v-if="step !== 1"
              size="md"
              squared
              variant="outline-primary"
              @click="previousStep"
              class="mr-2"
              style="float: right">
              <span>Previous</span>
            </b-button>
          </b-col>
        </b-row>
      </step>
      <div v-if="isLoadingPage"
         style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;
         background: rgba(255, 255, 255, .3); border-radius: 5px;">
      <align-middle>
        <div class="text-center">
          <strong class="fa fa-3x fa-spin fa-spinner"/>
        </div>
      </align-middle>
    </div>
    </b-card>
  </div>
</template>

<script>
  import SourceHeader from '../Sources/SourceHeader';
  import AlignMiddle from '../Sources/AlignMiddle';
  import {hasAllRequiredEntities} from '../../utils';
  import axios from 'axios';
  import Step from '../Sources/Step';
  import CardDetail from '../CardDetail';
  import { StripeCheckout } from '@vue-stripe/vue-stripe';
  import {getToken, setToken} from '../../utils';
  import { BIcon, BIconArrowUp, BIconArrowDown } from 'bootstrap-vue';

  
  export default {
    name: 'Plans',
    components: {
      CardDetail,
      Step,
      SourceHeader,
      AlignMiddle,
      StripeCheckout
    },

    data() {
      return {
        step: this.$store.state.general.user.plan_id==99 || this.$store.state.general.user.plan_id==100? 1: 2,
        totalSteps: 3,
        createProject: false,
        rawFile: null,
        project: this.$store.state.files.activeProject,
        projectFieldMap: {},
        projectFiles: {},
        meta: null,
        mapMeta: null,
        mapFile: {},
        new_plan_id: null,
        period: this.$store.state.general.user.cycle || 'monthly',
        period_statement: 'Switch to annual plan to save 20% off',
        publishableKey:"pk_live_51Hf4UAKZEbETiZAzuBDLYaOirPMhYRQdHY8oAVcP40JnEWzsbZoAabMjaUGNS1PrXdxVnQJrQ8qy8iSiLMMChOb200i5gNNFi1",
        // publishableKey: "pk_test_TYooMQauvdEDq54NiTphI7jx",
        sessionId: null,
        mapProject: null,
        isReady: false,
        modalKey: 1,
        plan_id: this.$store.state.general.user.plan_id,
        
        country: null,
        from_auth:null,
        paystack_url:null,
        verified:this.$store.state.general.user.verified,
        isLoadingPage: false,
        payment_option: null,

      };
    },
    props: {
      msgtitle: String,
      msgdescription: String,
      },

    watch: {
      rawFile: function(val) {
        console.log('Raw file: ', val);
        if (!!val) {
          this.file = val;
        }
      },
      plan_id:function(val){
        if (!!val){
          this.plan_id = val;
        }
      }
    },

    created(){
      
        // https://ipinfo.io
        // https://geoip-db.com/
        axios.get('https://ipinfo.io/json?token=2fc901f57bc5f3').then(({data}) =>{
        this.country = data.country;
        // this.country = 'USA';

        this.payment_option = data.country ==='GH'? "Paystack" : "Stripe";

          }).catch(e => {	console.log(e);
        this.user_info = this.$store.state.general.user;	
      });

    },


    methods: {
      TogglePlan(period){
        this.period = period;
      },
      user() {
        return this.$store.state.general.user;
      },
      show_calendly(){
          Calendly.showPopupWidget('https://calendly.com/superfluid-labs-intro/superscore-onboarding',
         );
          return false;
        },
      renewModalKey() {
        this.modalKey = this.modalKey + 1;
      },

      handleStyle(plan_id) {
        console.log("Plan ID: ", plan_id, (plan_id % 2) == 1 ? 1 : 2);
        return (plan_id % 2) == 1 ? 1 : 2;
      },
      
      formatNumber(number, decimals=0) {
        var SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];
        var tier = Math.log10(number) / 3 | 0;
        if(tier == 0) {
          if (number % 1 !== 0) {
            return round(number)
          }
          return number;
        }
        var suffix = SI_SYMBOL[tier];
        var scale = Math.pow(10, tier * 3);
        var scaled = number / scale;
        return scaled.toFixed(decimals) + suffix;
      },

      launchModal() {
        this.isMappingModalOpen = true;
        this.activeMeta = true;
      },

      selectPlan(plan_id) {
        if (!!plan_id) {
          this.plan_id = plan_id;
          this.nextStep();
          // console.log("The new plan_id is:", this.plan_id);
          this.new_plan_id = this.plan_id;
        }
      },


      nextStep() {
        this.step++;
        // if (this.step === 2) {
        //   this.project = this.$store.state.files.activeProject;
        // }
      },

      previousStep() {
        this.step--;
      },

      viewStandardInsights() {
        // this.$router.push(`/dashboard/${id}?view=insights`);
        this.$router.push(`/business-insights`);
      },

      viewInsights() {
        // this.$router.push(`/dashboard/${id}?view=insights`);
        this.$router.push(`/dashboard`);
      },

      payForPlan() {
        // https://account.superfluid.io/register?plan_id=1
        
        this.isLoadingPage = true;
        var plan_type = this.$store.state.general.user.plan_type;
     


        // var original_plan_id = plan_id;
        var stripe = Stripe(this.publishableKey);
        if (!!this.plan_id) {
          // this.plan_id = plan_id
      
          // if(plan_type === 'freebie'){
          //   this.plan_id = 4
          // } 
          // else if(plan_type === 'small_fee'){
          //   this.plan_id = 5
          // }
          // else{
          //   this.plan_id = original_plan_id;
          //   console.log("the original plan id is", this.plan_id);
          //   console.log("the original plan id is", this.plan_id);

          // }
          // this.plan_id = 4 ? plan_type==='free': plan_id;
          const token = getToken();
          
          axios.post('https://account.superfluid.io/gateway',{"token":token, 
          "plan_id":this.plan_id, "cycle": this.period}).then(({data})=>{
            this.from_auth = data;
            this.sessionId = data.stripe_session_id
             this.paystack_url = data.paystack_url

             
           
          }).then( session=>{
            this.isLoadingPage = false;

            // this.country = 'USA';
            if(this.country === 'GH'){
                console.log("This is True for ghana");
                return window.location.replace(this.paystack_url);
            }
            else{
                console.log("this is not for ghana")
                return stripe.redirectToCheckout({ sessionId:  this.sessionId });
            }
            
          }

          ).then(
            results=>{
              if (results.error){
                alert(results.error.message);

              }
            }
          ).catch(e => {console.error('Error',e)})
          

          /**
           * 1. Detect user's country
           * 2. Load PayStack payment option if user's country is Ghana
           * 3. Load Stripe payment option if user's country is not Ghana
           * 4. Send user to step 3 if payment is successful
           * */
          // this.$refs.checkoutRef.redirectToCheckout();
          // this.submit();
        }
        // this.nextStep();
      },

      show_payment_checkout() {
         
      },
      
      // You will be redirected to Stripe's secure checkout page
      submit () {
        this.$refs.checkoutRef.redirectToCheckout();
      },

      assetPath(asset) {
        return require("../../assets/" + asset);
      }
    },

    computed: {
      // file() {
      //   const {type} = this.meta;
      //   return this.$store.getters.getActiveFile(type);
      // },

      plans() {
        var plans = [];
        this.$store.state.general.plans.forEach(plan => {
          if (plan.plan_type !== "freebie" && plan.plan_type !== "small_fee") {
            if (plan.plan_type === "on_demand") {
              plan['name'] = "On Demand";
            }
            else if (plan.plan_type === "starter") {
              plan['name'] = "Starter";
            }
            else if (plan.plan_type === "enterprise") {
              plan['name'] = "Enterprise";
            }
            else {
              plan['name'] = "";
            }
            plans.push(plan);
          }
        });
        return plans;
      },
      
      plan_summary(){
        const filtered_plans =  this.plans.filter(x => x.plan_id === this.plan_id);
        if (this.plan_id === 2 && this.period === 'monthly'){
            return [{
              "Plan Selected": filtered_plans[0]['name'],
              "Price" : '$' + 119
            }]
        }
        else if(this.plan_id === 2 && this.period === 'annual'){
            return [{
              "Plan Selected": filtered_plans[0]['name'],
              "Price" : '$' + 99
            }]
        }
       else{ return [{
          "Plan Selected": filtered_plans[0]['name'],
          "Price" : '$' + filtered_plans[0]['amount']
        }]
       }
      },

      fileDetails() {
        var files = [];
        this.$store.state.files.fileList.forEach(file => {
          files.push(file);
        });
        return files;
      },

      verified_user(){
        if(!!this.verified){
          this.step = 3;
          return true;
        }
        else{
          return false;
        }
      },

      rawFiles() {
        return this.$store.state.files.fileList
      },
      
      files() {
        var files = [];
        this.$store.state.files.fileList.forEach(file => {
          files.push(file.originalName);
        });
        return files;
      },

      incompletenessMessage() {
        if (!this.file) {
          return this.meta.required ? 'Please provide a data file' : '';
        } else {
          return false;
          // return hasAllRequiredEntities(this.meta.entities, this.file.fieldMap || {}) ? '' :
          //   'Known column mapping is incomplete';
        }
      },
      
      metaList() {
        return this.$store.state.general.metas;
      },

      progress: function() {
        return Math.ceil(100 / this.totalSteps) * this.step;
      },
      
      mapMetaV1() {
        var map = {};
        this.$store.state.general.metas.forEach(meta => {
          map[meta['type']] = meta;
        });
        return map;
      },
    }
  };
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;900&display=swap");
section {
  font-family: Poppins, serif;
}

#togglePlanDivMobile {
  display: none;
}

.togglePlanDiv {
  margin: 1rem auto;
}
.togglePlanDiv .chooseBilling {
  padding-bottom: 1rem;
  color: white;
  font-size: 1.4rem;
  margin: 0;
}
.togglePlanDiv .saveOnAnnual {
  position: relative;
  /*.box.arrow-bottom:after {
    content: " ";
    position: absolute;
    right: 35%;
    bottom: -15px;
    border-top: 15px solid #0c71ce;
    border-right: 15px solid transparent;
    border-left: 15px solid transparent;
    border-bottom: none;
  }*/
}
.togglePlanDiv .saveOnAnnual .box {
  height: auto;
  color: #0c71ce;
  padding: 2rem 10px 0;
  position: relative;
  font-size: 1.3rem;
  line-height: 1.3rem;
}
.togglePlanDiv .togglePlan {
  /* margin-top: 0;
  margin-bottom: 0; */
  margin: auto;
  width: 30%;
  border-radius: 50px;
  padding: 2px !important;
  background: #f2f2f9;
  right: 0;
  top: 0;
  border: 1px #051a2b solid;
}
.togglePlanDiv .togglePlan .col-6 {
  margin: 1px 0px;
  padding: 1px 0;
}
.togglePlanDiv .togglePlan .col-6:first-child {
  padding-right: 10px;
}
.togglePlanDiv .togglePlan .col-6:last-child {
  padding-left: 10px;
}
.togglePlanDiv .togglePlan p {
  margin: 0 !important;
  font-size: 1.0rem;
  border-radius: 50px;
  padding: 0.4rem !important;
  color: #051a2b;
  cursor: pointer;
  transition: background ease-in-out 500ms, color ease-in-out 700ms;
}
.togglePlanDiv .togglePlan p:hover {
  box-shadow: 0 0 0 1px #0c71ce;
}
.togglePlanDiv .togglePlan .active {
  background: #0c71ce;
  color: white;
  transition: background ease-in-out 500ms, color ease-in-out 700ms;
}
.togglePlanDiv .togglePlan .active:hover {
  box-shadow: none;
}

#pricing-tabs {
  text-align: center;
  /* background-color: #f2f2f2; */
  padding-bottom: 3rem;
  /* --------------- */
  /* --------------- */
}
#pricing-tabs #fdw-pricing-table {
  margin: auto 0;
  text-align: center;
  width: 100%;
  /* total computed width */
  zoom: normal;
  display: inline-block;
}
#pricing-tabs #fdw-pricing-table:before, #pricing-tabs #fdw-pricing-table:after {
  content: "";
  display: table;
}
#pricing-tabs #fdw-pricing-table:after {
  clear: both;
}
#pricing-tabs #fdw-pricing-table .plan {
  font-size: 13px;
  background: #fff;
  /* height: 580px !important; */
  height: 600px !important;

  border: none;
  color: #333;
  padding: 30px;
  width: 33.33%;
  float: left;
  _display: inline;
  /* IE6 double margin fix */
  position: relative;
  margin: 0;
  -moz-box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.3);
}
#pricing-tabs #fdw-pricing-table .plan ul li {
  padding: 0 !important;
}
#pricing-tabs #fdw-pricing-table .plan:after {
  z-index: -1;
  position: absolute;
  content: "";
  bottom: 10px;
  right: 4px;
  width: 80%;
  top: 80%;
  -webkit-box-shadow: 0 12px 5px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 12px 5px rgba(0, 0, 0, 0.3);
  box-shadow: 0 12px 5px rgba(0, 0, 0, 0.3);
  -webkit-transform: rotate(3deg);
  -moz-transform: rotate(3deg);
  -o-transform: rotate(3deg);
  -ms-transform: rotate(3deg);
  transform: rotate(3deg);
}
#pricing-tabs #fdw-pricing-table .header {
  position: relative;
  font-size: 20px;
  text-transform: none;
  color: #0c71ce;
  font-weight: bold;
  padding: 0px 40px;
}
#pricing-tabs #fdw-pricing-table .popular-plan {
  top: -20px;
  padding: 40px 20px;
  color: white;
  height: 620px;
}
#pricing-tabs #fdw-pricing-table .popular-plan .header {
  color: white;
}
#pricing-tabs #fdw-pricing-table .header:after {
  position: absolute;
  bottom: -8px;
  left: 0;
  height: 3px;
  width: 100%;
  content: "";
}
#pricing-tabs #fdw-pricing-table .popular-plan .header {
  margin-top: -40px;
  padding-top: 60px;
}
#pricing-tabs #fdw-pricing-table .plan1 {
  background-color: #dae3f3;
}
#pricing-tabs #fdw-pricing-table .plan2 {
  background-color: #b4c7e7;
  /* new */
   /* margin-top: -15px; */
   /* margin-top: 2px; */
  padding-top: 60px;
  height: 600px;
  border-radius: 0px;

}
#pricing-tabs #fdw-pricing-table .plan3 {
  background-color: #0c71ce;
}
#pricing-tabs #fdw-pricing-table .planTop {
  line-height: 1.7em;
  height: 80px;
  padding-top: 1rem;
  border-bottom: 1px rgba(0, 0, 0, 0.15) solid;
}
#pricing-tabs #fdw-pricing-table .planTopEnterprise {
  line-height: 1.7em;
  height: 80px;
  padding-top: 2.6rem;
  padding-bottom: 5rem;
  border-bottom: 1px rgba(0, 0, 0, 0.15) solid;
}

#pricing-tabs #fdw-pricing-table .plan4 {
  background-color: #dae3f3;
}
#pricing-tabs #fdw-pricing-table .price {
  margin-top: 0.5rem;
  font-size: 45px;
}
#pricing-tabs #fdw-pricing-table .contact-sales {
  font-size: 25px;
}
#pricing-tabs #fdw-pricing-table .monthly {
  font-size: 13px;
  margin-bottom: 5px;
}
#pricing-tabs #fdw-pricing-table ul {
  text-align: left;
  margin: 5px 0 5px 0.7rem;
  padding: 0;
  list-style: none;
}
#pricing-tabs #fdw-pricing-table li {
  padding: 5px 0;
}
/* #pricing-tabs #fdw-pricing-table .signup {
  padding: 8px 20px !important;
  position: absolute;
  bottom: 20px;
 
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  text-transform: uppercase;
  text-decoration: none;
  display: inline-block;
  background-color: #ffc629;
  border-radius: 100px;
  -moz-border-radius: 100px;
  -webkit-border-radius: 100px;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.15);
  opacity: 0.9;
}
.signup {
  padding: 8px 20px !important;
  transform: translate(-50%, -50%);
  color: black;
  text-transform: uppercase;
  text-decoration: none;
  display: inline-block;
  background-color: #ffc629;
  border-radius: 100px;
  -moz-border-radius: 100px;
  -webkit-border-radius: 100px;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.15);
  opacity: 0.9;
} */
  

/* new */
#pricing-tabs #fdw-pricing-table .signup {
  padding: 8px 20px !important;
  color: black;
  text-transform: uppercase;
  text-decoration: none;
  display: inline-block;
  background-color: #ffc629;
  border-radius: 100px;
  -moz-border-radius: 100px;
  -webkit-border-radius: 100px;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.15);
  opacity: 0.9;
}

#pricing-tabs #fdw-pricing-table .signup:hover {
  opacity: 1;
}
.most-popular {
  position: absolute;
  top: 25px;
  left: 50%;
  transform: translate(-50%, -50%);
  text-transform: uppercase;
}

#pricing-tabs #fdw-pricing-table .signup:active {
  -moz-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3) inset;
  -webkit-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3) inset;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3) inset;
}
#pricing-tabs #fdw-pricing-table .popular-plan .signup {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translate(-50%, -50%);
}
#pricing-tabs #fdw-pricing-table .plan1 .signup {
  background: #0c71ce;
  color: white;
}
#pricing-tabs #pricing-table-mobile {
  display: none;
}

@media all and (max-width: 768px) {
  #fdw-pricing-table {
    display: none !important;
  }

  #pricing-table-mobile {
    display: block !important;
    /* padding: 2rem; */
    text-align: left;
    color: black;
  }
  #pricing-table-mobile .plan {
    padding: 1.5rem;
  }
  #pricing-table-mobile .plan .header {
    position: relative;
    font-size: 20px;
    text-transform: none;
    color: #0c71ce;
    font-weight: bold;
  }
  #pricing-table-mobile .plan .price {
    font-size: 2rem;
    padding: 0;
  }
  #pricing-table-mobile .plan .signup {
    margin: 0% 45% !important;

    width: 100%;
    padding: 0.8rem !important;
    /* margin-left: 100px; */
    /* margin-left: auto;
    margin-right: auto; */
    text-align: center;
    display: inline-block;
    color: black;
    font: bold 14px Poppins;
    text-transform: uppercase;
    text-decoration: none;
    background-color: #ffc629;
    border-radius: 80px;
    -moz-border-radius: 80px;
    -webkit-border-radius: 80px;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.15);
    opacity: 0.9;
  }
  #pricing-table-mobile .plan hr {
    margin: 0 !important;
    border-color: rgba(0, 0, 0, 0.15);
  }
  #pricing-table-mobile .plan .ul-features {
    display: none;
    list-style-type:none;
  }
  #pricing-table-mobile .plan ul {
    margin-top: 0 !important;
    padding: 0.5rem 0;
    border-bottom: 1px rgba(0, 0, 0, 0.15) solid;
    list-style-type:none;
  }
  #pricing-table-mobile .plan ul li {
    padding: 3px 0;
  }
  #pricing-table-mobile .plan .features-viewLess {
    display: none;
    padding-top: 1rem;
  }
  #pricing-table-mobile .plan .features-viewMore {
    padding-top: 1rem;
  }
  #pricing-table-mobile .plan #ul-features-plan1 {
    display: block;
  }
  #pricing-table-mobile .plan #features-viewMore-plan1 {
    display: none;
  }
  #pricing-table-mobile .plan #features-viewLess-plan1 {
    display: block;
  }
  #pricing-table-mobile .popular-plan {
    color: white;
  }
  #pricing-table-mobile .popular-plan .header {
    color: white;
  }
  #pricing-table-mobile .plan1 {
    background-color: #dae3f3;
    /* background-color: #0c71ce; */

  }
  #pricing-table-mobile .plan1 .signup {
    background: #0c71ce;
    color: white;
    margin: 0% 45% !important;
   
    width: 100%;
    /* margin-left: 100px; */
    text-align: center;
    display: inline-block;
   
  }
  #pricing-table-mobile .plan2 {
    /* background-color: #b4c7e7; */
    background-color: #0c71ce;

  }
  #pricing-table-mobile .plan3 {
    background-color: #0c71ce;
  }
  #pricing-table-mobile .plan4 {
    /* background-color: #dae3f3; */
    background-color: #0c71ce;

  }
  #pricing-table-mobile .plan4 .contact-sales {
    margin: 10% 0;
    font-weight: bold;
    height: 45px;
    font-size: 22px;
  }
}


#pricing-tabs2 {
  text-align: center;
  /* background-color: #f2f2f2; */
  padding-bottom: 3rem;
  /* --------------- */
  /* --------------- */
}
#pricing-tabs2 #fdw-pricing-table2 {
  margin: auto 0;
  text-align: center;
  width: 100%;
  /* total computed width */
  zoom: normal;
  display: inline-block;
}
#pricing-tabs2 #fdw-pricing-table2:before, #pricing-tabs2 #fdw-pricing-table2:after {
  content: "";
  display: table;
}
#pricing-tabs2 #fdw-pricing-table2:after {
  clear: both;
}
#pricing-tabs2 #fdw-pricing-table2 .pay {
  font-size: 13px;
  background: #fff;
  height: 200px !important;
  border: none;
  color: #333;
  padding: 30px;
  width: 50%;
  float: left;
  _display: inline;
  /* IE6 double margin fix */
  position: relative;
  margin: 0;
  -moz-box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.3);
}
#pricing-tabs2 #fdw-pricing-table2 .pay ul li {
  padding: 0 !important;
}
#pricing-tabs2 #fdw-pricing-table2 .pay:after {
  z-index: -1;
  position: absolute;
  content: "";
  bottom: 10px;
  right: 4px;
  width: 80%;
  top: 80%;
  -webkit-box-shadow: 0 12px 5px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 12px 5px rgba(0, 0, 0, 0.3);
  box-shadow: 0 12px 5px rgba(0, 0, 0, 0.3);
  -webkit-transform: rotate(3deg);
  -moz-transform: rotate(3deg);
  -o-transform: rotate(3deg);
  -ms-transform: rotate(3deg);
  transform: rotate(3deg);
}

#pricing-tabs2 #fdw-pricing-table2 .plan1 {
  background-color: #dae3f3;
}
#pricing-tabs2 #fdw-pricing-table2 .plan2 {
  background-color: #b4c7e7;
}
</style>
